import type { ToolInvocation } from 'ai';
import { memo } from 'react';
import { useToolCallText } from '~/components/chat/assistant-message/hooks/useToolCallText';
import { TextShimmer } from '~/components/ui/TextShimmer';
import { classNames } from '~/utils/classNames';

export const ToolCallText = memo(
  ({ toolInvocation, isPending }: { toolInvocation: ToolInvocation; isPending?: boolean }) => {
    const { state } = toolInvocation;

    const hasResult = 'result' in toolInvocation;
    const hasFailed = state === 'result' && toolInvocation.result.type === 'error' && toolInvocation.result.content;

    const { icon, title, value } = useToolCallText(toolInvocation, isPending || false);

    return (
      <>
        <div className="h-6 flex items-center">
          <i
            className={classNames(
              'size-4.5 shrink-0 text-bolt-elements-icon-secondary group-hover/button:text-bolt-ds-textPrimary transition-theme',
              icon,
            )}
          />
        </div>

        <div className="text-bolt-ds-textSecondary group-hover/button:text-bolt-ds-textPrimary transition-theme font-normal text-left overflow-hidden">
          <div className="flex min-h-6 items-center gap-2 leading-6 truncate">
            {(hasResult && !isPending) || hasFailed ? (
              <div className="truncate">{title}</div>
            ) : (
              <TextShimmer
                className="[--base-color:var(--bolt-elements-textTertiary)] dark:[--base-color:var(--bolt-elements-textSecondary)] [--base-gradient-color:var(--bolt-elements-textPrimary)] truncate inline"
                duration={1.5}
                spread={2}
              >
                {title}
              </TextShimmer>
            )}

            {value && (
              <code className="text-bolt-ds-textPrimary truncate bg-bolt-ds-surfaceHighlight p-1 px-1.5 text-xs rounded">
                {value}
              </code>
            )}
          </div>
        </div>
      </>
    );
  },
);
